const axios = require("axios").default;

class ApiService {
    static async sendRequest(requestType, url, body = null) {
        if (requestType == RequestType.GET) {
            return await axios.get(url, { validateStatus: status => status < 500 });
        }
        else if (requestType == RequestType.POST) {
            return await axios.post(url, body, { validateStatus: status => status < 500 });
        }
    }
}

class ApiRoutes {
    static baseURL = "https://share-link-api.herokuapp.com/";
    
    static loginURL = this.baseURL + "user/login/";
    static registerURL = this.baseURL + "user/register/";

    static getUserURL = this.baseURL + "user/getUser";
    static getProfileURL = this.baseURL + "user/getProfile";

    static getProfileSettingsURL = this.baseURL + "user/getProfileSettings";
    static setProfileSettingsURL = this.baseURL + "user/setProfileSettings";
}

const RequestType = {
    GET: "get",
    POST: "post"
}

module.exports = {
    ApiService,
    ApiRoutes,
    RequestType
}
